var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"64829E7E-F31A-4843-9A7A-F3E46E5A491C@1x"),React.createElement("g",{"id":"01-Logos/Icons/Button","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"icons-/-navigation-/-S-/-menu","fill":"#1E1E1E"},React.createElement("path",{"d":"M22,15.4 L22,17 L2,17 L2,15.4 L22,15.4 Z M22,7 L22,8.6 L2,8.6 L2,7 L22,7 Z","id":"nav-menu"})))]);
}

Menu.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Menu;

Menu.default = Menu;
